import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { themeCreator } from "./styles/themes/base";
import App from "./app/App";
import { StylesProvider } from "@mui/styles";

const curThemeName = localStorage.getItem("appTheme") || "PureLightTheme";
const themeName = curThemeName;
const theme = themeCreator(themeName);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StylesProvider>
  </BrowserRouter>
);
